export function formatDuration(value: number, unit: 'ms' | 'seconds' = 'ms'): string {
  if (!Number.isFinite(value) || value < 0) return '00:00';
  const totalSec = Math.round(unit === 'ms' ? value / 1000 : value);
  const m = Math.floor(totalSec / 60)
    .toString()
    .padStart(2, '0');
  const s = (totalSec % 60).toString().padStart(2, '0');
  return `${m}:${s}`;
}
